import { render, staticRenderFns } from "./swift_M3.vue?vue&type=template&id=07ff67ac&scoped=true&"
import script from "./swift_M3.vue?vue&type=script&lang=js&"
export * from "./swift_M3.vue?vue&type=script&lang=js&"
import style0 from "./swift_M3.vue?vue&type=style&index=0&id=07ff67ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff67ac",
  null
  
)

export default component.exports